module.exports = __webpack_public_path__ + "img/coupon_tutorial_romakyun01.c2b3caeb.png";